import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import GenericArticlePage from "../pages/article/GenericArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandabuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/:slug",
    element: <GenericArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;